<template>
	<div id="tags-view-container" class="tags-view-container"
		style="box-shadow: rgba(204, 204, 204, 0.35) 18px 10px 8px -15px inset;margin:0px;">
		<hamburger id="hamburger-container" class="hamburger-container" @toggleClick="toggleSideBar"
			style="position:absolute;z-index:10;top: 14.5px;left: 15px;" />
		<breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

		<scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll" style="padding-left:0px;">
			<router-link v-for="tag in visitedViews"
				ref="tag" :key="tag.path"
				:class="isActive(tag)?'active':''"
				:to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
				tag="span" class="tags-view-item" :style="activeStyle(tag)"
				@click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
				@contextmenu.prevent.native="openMenu(tag,$event)"
			>
				{{$t(tag.title)}}
				<span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
			</router-link>
		</scroll-pane>

		<ul v-show="visible" :style="{left:left+'px'}" class="contextmenu">
			<li @click="refreshSelectedTag(selectedTag)">刷新页面</li>
			<li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭当前</li>
			<li @click="closeOthersTags">关闭其他</li>
			<li @click="closeAllTags(selectedTag)">关闭所有</li>
		</ul>
	</div>
</template>

<script>
	import ScrollPane from './ScrollPane'
	import path from 'path'
	import Breadcrumb from '@/components/Breadcrumb'
	import Hamburger from '../../../components/Hamburger/index.vue'

	export default {
		components: {
			ScrollPane,
			Hamburger,
			Breadcrumb,
		},
		data() {
			return {
				visible: false,
				top: 0,
				left: 0,
				selectedTag: {},
				affixTags: []
			}
		},
		// 监控自己定义的变量
		computed: {
			visitedViews() {
				return this.$store.state.tagsView.visitedViews
			},
			routes() {
				return this.$store.state.permission.routes
			},
			theme() {
				return this.$store.state.settings.theme;
			}
		},
		watch: {
			$route() {
				this.addTags()
				this.moveToCurrentTag()
			},
			visible(value) {
				if (value) {
					document.body.addEventListener('click', this.closeMenu)
				} else {
					document.body.removeEventListener('click', this.closeMenu)
				}
			}
		},
		mounted() {
			this.initTags()
			this.addTags()
		},
		methods: {
			isActive(route) {
				return route.path === this.$route.path
			},
			activeStyle(tag) {
				if (!this.isActive(tag)) return {};
				return {
					"background-color": this.theme,
					"border-color": this.theme
				};
			},
			isAffix(tag) {
				return tag.meta && tag.meta.affix
			},
			filterAffixTags(routes, basePath = '/') {
				let tags = []
				routes.forEach(route => {
					if (route.meta && route.meta.affix) {
						const tagPath = path.resolve(basePath, route.path)
						tags.push({
							fullPath: tagPath,
							path: tagPath,
							name: route.name,
							meta: {
								...route.meta
							}
						})
					}
					if (route.children) {
						const tempTags = this.filterAffixTags(route.children, route.path)
						if (tempTags.length >= 1) {
							tags = [...tags, ...tempTags]
						}
					}
				})
				return tags
			},
			initTags() {
				const affixTags = this.affixTags = this.filterAffixTags(this.routes)
				for (const tag of affixTags) {
					// Must have tag name
					if (tag.name) {
						this.$store.dispatch('tagsView/addVisitedView', tag)
					}
				}
			},
			addTags() {
				const {name} = this.$route
				if (name) {
					this.$store.dispatch('tagsView/addView', this.$route)
				}
				return false
			},
			moveToCurrentTag() {
				const tags = this.$refs.tag
				this.$nextTick(() => {
					for (const tag of tags) {
						if (tag.to.path === this.$route.path) {
							this.$refs.scrollPane.moveToTarget(tag)
							// when query is different then update
							if (tag.to.fullPath !== this.$route.fullPath) {
								this.$store.dispatch('tagsView/updateVisitedView', this.$route)
							}
							break
						}
					}
				})
			},
			refreshSelectedTag(view) {
				this.$store.dispatch('tagsView/delCachedView', view).then(() => {
					const {
						fullPath
					} = view
					this.$nextTick(() => {
						this.$router.replace({
							path: '/redirect' + fullPath
						})
					})
				})
			},
			closeSelectedTag(view) {
				this.$store.dispatch('tagsView/delView', view).then(({
					visitedViews
				}) => {
					if (this.isActive(view)) {
						this.toLastView(visitedViews, view)
					}
				})
			},
			closeOthersTags() {
				this.$router.push(this.selectedTag)
				this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
					this.moveToCurrentTag()
				})
			},
			closeAllTags(view) {
				this.$store.dispatch('tagsView/delAllViews').then(({
					visitedViews
				}) => {
					if (this.affixTags.some(tag => tag.path === view.path)) {
						return
					}
					this.toLastView(visitedViews, view)
				})
			},
			toLastView(visitedViews, view) {
				const latestView = visitedViews.slice(-1)[0]
				if (latestView) {
					this.$router.push(latestView.fullPath)
				} else {
					// now the default is to redirect to the home page if there is no tags-view,
					// you can adjust it according to your needs.
					if (view.name === 'Dashboard') {
						// to reload home page
						this.$router.replace({
							path: '/redirect' + view.fullPath
						})
					} else {
						this.$router.push('/')
					}
				}
			},
			openMenu(tag, e) {
				const menuMinWidth = 105
				const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
				const offsetWidth = this.$el.offsetWidth // container width
				const maxLeft = offsetWidth - menuMinWidth // left boundary
				const left = e.clientX - offsetLeft + 15 // 15: margin right

				if (left > maxLeft) {
					this.left = maxLeft
				} else {
					this.left = left
				}

				this.top = 25 //e.clientY
				this.visible = true
				this.selectedTag = tag
			},
			closeMenu() {
				this.visible = false
			},
			handleScroll() {
				this.closeMenu()
			},
			toggleSideBar() {
				this.$store.dispatch('app/toggleSideBar');
			},
		}
	}
</script>

<style lang="scss" scoped>
	.hamburger-container {
		padding: 0px 15px 0px 4px !important;
	}

	.breadcrumb-container {
		margin-left: 52px !important;
	}

	.tags-view-container .tags-view-wrapper .tags-view-item.active::before {
		display: none !important;
	}

	.tags-view-container .tags-view-wrapper .tags-view-item.active {}

	.tags-view-container {
		width: 100%;
		height: auto;
		/* background: #fff;
		border-bottom: 1px solid #d8dce5;
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04); */

		.tags-view-wrapper {
			.tags-view-item {
				display: inline-block;
				position: relative;
				cursor: pointer;
				height: 32px;
				line-height: 32px;
				border: 1px solid #f3f3f3;
				border-bottom: none;
				color: #767676;
				background: #f3f3f3;
				padding: 0 10px;
				font-size: 14px;
				margin-left: 10px;
				border-radius: 5px 5px 0 0;
				margin-bottom: 6px;

				&:first-of-type {
					margin-left: 4px;
				}

				&:last-of-type {
					margin-right: 15px;
				}

				&.active {
					background-color: #FFFFFF !important;
					color: #2c9ae9;
					border-color: #1c81d9;

					&::before {
						content: '';
						display: inline-block;
					}
				}
			}
		}

		.contextmenu {
			margin: 0;
			background: #fff;
			z-index: 3000;
			position: absolute;
			list-style-type: none;
			padding: 5px 0;
			border-radius: 4px;
			font-size: 12px;
			font-weight: 400;
			color: #333;
			box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
			top: 82px;

			li {
				margin: 0;
				padding: 7px 16px;
				cursor: pointer;

				&:hover {
					background: #eee;
				}
			}
		}
	}
</style>

<style lang="scss">
	//reset element css of el-icon-close
	.tags-view-wrapper {
		.tags-view-item {
			.el-icon-close {
				width: 16px;
				height: 16px;
				vertical-align: 2px;
				border-radius: 50%;
				text-align: center;
				transition: all .3s cubic-bezier(.645, .045, .355, 1);
				transform-origin: 100% 50%;

				&:before {
					transform: scale(.6);
					display: inline-block;
					vertical-align: -1.3px;
				}

				&:hover {
					background-color: #b4bccc;
					color: #fff;
				}
			}
		}
	}
</style>
